import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"

import { ISOToDateFormat } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";
import { replaceNumberQuestion } from "helpers/ConvertString"

import * as Alert from "alertService"

import wordingQuestion from "configs/wordingQuestion.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
import Autocomplete from "components/Autocomplete/Select.jsx";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import SearchIcon from "@material-ui/icons/Search";

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components
import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import FormLabel from "@material-ui/core/FormLabel"
import { colors } from "@material-ui/core"
import { ISOToDateYMD, ISOToDateYMDAndFullTime } from "helpers/ConvertDate" 
const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}

var userCode = Auth.getUserData()

class LeadExpiredPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      startDateTime: "",
      endDateTime: "",
      dataListSetting: [
        {
          name: "ALL",
          value: "ALL"
        },
        {
          name: "Success",
          value: "Success"
        },
        {
          name: "Doing",
          value: "Doing"
        }
      ],
      currentSettingId: "ALL",
      dataTableList: [],
      statusDialogOpen: false,
      rawData: [],
      currentData: {},
      currentUserName: "",
      dataDealer:[],
      currentBranchName: [],
      dataLead: [],
      currentLeadName: [],
    }
  }
  componentDidMount() { 
    // this.loadDataTableList(false)
    Alert.Loading()
    this.loadDealerDataList(() => {
      Alert.LoadingClose()
    })
  }
  loadDataTableList = (writeExcel = false, callback) => {
    Alert.Loading()
    const dateS = this.state.startDateTime ? this.state.startDateTime : ""
    const dateE = this.state.endDateTime ? new Date(new Date(this.state.endDateTime).getTime() + 86399000).toISOString() : ""
    // ["545511","165161"]
    var dealerID_array = ""
    this.state.currentBranchName.map((data,index)=>{
        if(index != 0){
          dealerID_array += ","
        }
        dealerID_array += data.value 
      }) 
    const dataForSend = {
      startDate: dateS,
      endDate: dateE, 
      leadID: this.state.currentLeadName,
      dealerID: dealerID_array
    }
    // URL_POST_LEADUSE_EXPIRED
    APIPost(UrlServer.URL_POST_LEADUSE_EXPIRED, dataForSend, ({ datas }) => {
      var dataList = this.renderListData(datas)
      this.setState({
        rawData: datas,
        dataTableList: dataList
      }, () => {
        Alert.LoadingClose()
        if (callback) callback(datas)
      })
    })
  }

  loadDealerDataList = (callback) => {
    APIPost(UrlServer.URL_POST_GET_DEALER, {dealer_code: userCode.dealer_code}, ({ datas }) => {
      var newConvertDatas = arrayObject(datas, [
        {
          oldKey: "dealer_code",
          newKey: "value"
        },
        {
          oldKey: "branch_name",
          newKey: "label"
        }
      ]
      )
      this.setState({
        dataDealer: newConvertDatas
      }, () => {
        this.loadSourceLeadDataList(() => {
          callback()
        })
      });
    })
  }

  loadSourceLeadDataList = (callback) => {
    APIPost( UrlServer.URL_POST_IMPORT_EXCEL_LEAD_SETTING_DATA_LIST,{},({datas})=>{ 
      
      var newConvertDatas = arrayObject(datas,[
          {
            oldKey:"_id",
            newKey:"value"
          },
          {
            oldKey:"description",
            newKey:"label"
          },
          {
            oldKey:"created_date_iso",
            newKey:"created_date_iso"
          },
          {
            oldKey:"total_leads",
            newKey:"total_leads"
          }
        ]
      )
      newConvertDatas.map((data,index)=>{ 
        newConvertDatas[index]["label"] = data["label"] + " : " + ISOToDateYMDAndFullTime(data["created_date_iso"])
      })
      this.setState({  
        dataLead:newConvertDatas
        },()=>{ 
          callback()
        }); 
    })  
  }
  
  downLoadExcel = (e) => {

    if(this.state.currentLeadName == "" || !this.state.currentLeadName){
      WarningCallback("กรุณาเลือกข้อมูลที่นำเข้า",()=>{ 
      })
      return 
    }

    // if(this.state.currentBranchName == "" || !this.state.currentBranchName){
    //   WarningCallback("กรุณาเลือกสาขา",()=>{ 
    //   })
    //   return 
    // }

    const dateS = this.state.startDateTime ? this.state.startDateTime : ""
    const dateE = this.state.endDateTime ? new Date(new Date(this.state.endDateTime).getTime() + 86399000).toISOString() : ""
    const dataForSend = {
      startdate: dateS,
      enddate: dateE,
      leadID: this.state.currentLeadName,
      dealerID: this.state.currentBranchName,
    }

    Alert.Loading()
    APIPost(UrlServer.URL_POST_RAWDATA_DOWNLOAD_EXCEL_RAWDATAEXPIRED, dataForSend, ({ datas }) => {
      Alert.LoadingClose()
      const response = {
        file: ConfigHost.HOST_API + "files/" + datas.fileName,
      };
      document.location = response.file
    })
  }

  handleDialogClose = () => {
    this.setState({ statusDialogOpen: false })
  }

  handleDialogOpen = (index) => {
    this.setState({
      currentData: this.state.rawData[index],
      currentUserName: this.state.rawData[index].cus_id.first_name + " " + this.state.rawData[index].cus_id.last_name
    }, () => {
      this.setState({ statusDialogOpen: true })
    })
  }
  handleChangeAutoComplete = name => value => {  
    this.setState({
      [name] : value,
    });
  };
  renderListData = data => {
   
    return data.map((CData, key) => {
      var browser = {}
      if(CData.last_active_by_browser){
        browser = JSON.parse(CData.last_active_by_browser)
      } 
      return {
        no: key + 1,
        description: CData.lead_setting_id.description,
        branch_name: CData.branch_name,
        FName: CData.first_name,
        LName: CData.last_name,
        Tel: CData.tel, 
        send_sms_date: ISOToDateFormat(CData.send_sms_date), 
        sms_expired_date: ISOToDateFormat(CData.sms_expired_date), 
        actions: ""
      }
    })
  }

  handleDateTimeChange = (name, date) => {
    const dateF = new Date(date).toISOString()
    this.setState({
      [name]: dateF
    })
  }
  handleChange = name => event => {

    this.setState({
      [name]: event.target.value
    })
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  setBranchName = (key,data,txt)=> {
    if( key == "q1"){ 
      return txt.replace("<?{branch_name}?>",data.branch_name)
    }else{
      return txt
    }
  } 

  handleSearch = () => {
    if(this.state.currentLeadName == "" || !this.state.currentLeadName){
      WarningCallback("กรุณาเลือกข้อมูลที่นำเข้า",()=>{ 
      })
      return 
    }

    // if(this.state.currentBranchName == "" || !this.state.currentBranchName){
    //   WarningCallback("กรุณาเลือกสาขา",()=>{ 
    //   })
    //   return 
    // }


    this.loadDataTableList(false)
  }
  handleDownloadExcelFile = () => {
    this.loadDataTableList(true, (datas) => {
      const response = {
        file: ConfigHost.HOST_API + "reports/" + datas.fileName,
      };
      document.location = response.file
    })
  }
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                ออกรายงาน
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer >
                    <GridItem xs={12} sm={12} md={12}>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={6} className="date-responsive">
                          <InputLabel className={classes.label}>
                            วันที่เริ่ม (วันหมดอายุ SMS)
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("startDateTime", e)}
                              inputProps={{
                                placeholder: "กดเลือกวันที่ตรงนี้", 
                                readOnly: true
                              }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6} className="date-responsive">
                          <InputLabel className={classes.label}>
                            ถึงวันที่ (วันหมดอายุ SMS)
                          </InputLabel>
                          <br />
                          <FormControl fullWidth>
                            <Datetime
                              timeFormat={false}
                              onChange={e => this.handleDateTimeChange("endDateTime", e)}
                              inputProps={{ placeholder: "กดเลือกวันที่ตรงนี้",
                              readOnly: true }}
                            />
                          </FormControl>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} className={"autocomplete-space"}> 
                          {
                            (this.state.dataLead.length > 0) ? 
                            <Autocomplete
                              handleChange={this.handleChangeAutoComplete}
                              value={this.state.currentLeadName}
                              dataList={this.state.dataLead}
                              id ="currentLeadName"
                              label="เลือกข้อมูลที่นำเข้า"
                            />
                            : ""
                          } 
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12} className={"autocomplete-space"}>
                            {
                              (this.state.dataDealer.length > 0) ? 
                              <Autocomplete
                                handleChange={this.handleChangeAutoComplete}
                                value={this.state.currentBranchName}
                                dataList={this.state.dataDealer}
                                multi
                                id ="currentBranchName"
                                label="เลือกสาขา"
                              />
                              : ""
                            }
                        </GridItem>

                        {/* <GridItem xs={12} sm={12} md={12}>
                          <GridContainer >
                            <GridItem xs={12} sm={12} md={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                ชื่อข้อมูล Lead ที่นำเข้า
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10}>
                              {
                                (this.state.dataListSetting.length > 0) ?
                                  <Select
                                    value={this.state.currentSettingId}
                                    listData={this.state.dataListSetting}
                                    onChange={this.handleChange("currentSettingId")}
                                  />
                                  : ""
                              }
                            </GridItem>
                          </GridContainer>
                        </GridItem> */}
                      </GridContainer>
                      <hr />
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <Button
                            round
                            color="primary"
                            onClick={this.handleSearch}
                          >
                            <SearchIcon className={classes.icons} />
                            ค้นหา
                          </Button>
                          {" "}
                          <Button
                            round
                            color="info"
                            onClick={this.downLoadExcel}
                          >
                            <CloudDownloadIcon className={classes.icons} />
                            ดาวน์โหลด
                          </Button>
                        </GridItem>
                      </GridContainer>
                      <hr />
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={12} sm={12} md={12}>
                          <span>จำนวน {thaiBath(this.state.dataTableList.length, false)} รายการ</span>
                          <ReactTable 
                            className="table-scroll"
                            data={this.state.dataTableList}
                            filterable
                            columns={[
                              {
                                Header: "No",
                                accessor: "no",
                                width: 50
                              },  
                              {
                                Header: "แหล่งข้อมูล",
                                accessor: "description", 
                                width: 200
                              },
                              {
                                Header: "สาขา",
                                accessor: "branch_name", 
                                width: 250
                              },
                              {
                                Header: "ชื่อ",
                                accessor: "FName",
                                width: 170
                              },
                              {
                                Header: "นามสกุล",
                                accessor: "LName",
                                width: 170
                              },
                              {
                                Header: "เบอร์โทร",
                                accessor: "Tel",
                                width: 170
                              }, 
                              {
                                Header: "วันระบุส่ง SMS",
                                accessor: "send_sms_date",
                                width: 170
                              }, 
                              {
                                Header: "วันหมดอายุ SMS",
                                accessor: "sms_expired_date",
                                width: 170
                              }, 
                              {
                                Header: "Actions",
                                accessor: "actions",
                                sortable: false,
                                filterable: false,
                                width: 170,
                              },

                            ]}
                            defaultPageSize={10}
                            showPaginationTop
                          // showPaginationBottom={false}
                          // className="-striped -highlight"
                          />
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}
export default withStyles(styles)(LeadExpiredPage)
